module.exports = __webpack_public_path__ + "img/Illustration_No_Register@3x.png";